import { PropsWithChildren, useEffect, useRef } from 'react';
import Div from './div';

interface H1Props {
    id?: string
    className?: string
    title?: boolean
    /** allow parent component to get ref to trigger focus manually */
    headingRef?: (h1: HTMLHeadingElement | null) => void
}

const H1 = (props: PropsWithChildren<H1Props>) => {
    const {
        className = '',
        title = false,
        ...otherProps
    } = props;
    const fontSize = (title) ? 'ds-text-heading--4xl' : 'ds-text-heading--3xl';

    const ref = useRef<HTMLHeadingElement | null>(null);

    useEffect(() => {
        if (ref.current) {
            setTimeout(() => {
                ref.current?.focus();
            }, 10);
        }
    }, []);

    const { headingRef } = props;
    useEffect(() => {
        if (headingRef) {
            headingRef(ref.current);
        }
    }, [headingRef]);

    return <>
        <Div paddingTop={5} paddingTopMD={3}>
            <h1
                className={`${className} ${fontSize}`}
                tabIndex={-1}
                ref={ref}
                {...otherProps}
            >{props.children}</h1>
        </Div>
    </>;
};

export default H1;